import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { message: String, tone: { type: String, default: "info" } }

  connect() {
    const seed = document.getElementById('initial-flashes')
    if (seed && seed.textContent?.trim()) {
      try {
        const items = JSON.parse(seed.textContent)
        items.forEach(({ message, tone }) => this.render(message, tone))
        seed.remove()
      } catch (_) {}
    }
  }

  show(event) {
    if (event) event.preventDefault()
    const msg = this.messageValue || this.element.dataset.notifyMessage || "Action not available yet."
    const tone = this._normalizeTone(this.toneValue || this.element.dataset.notifyTone)
    this.render(msg, tone)
  }

  render(message, tone = 'info') {
    const root = document.getElementById('flash-root') || this._createRoot()
    const tpl = document.getElementById('toast-template')
    if (!tpl) return
    const node = tpl.content.firstElementChild.cloneNode(true)

    const map = {
      info:    { border: 'border-blue-200',    bg: 'bg-blue-50',    text: 'text-blue-900',   icon: '<svg class="h-5 w-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM9 9a1 1 0 112 0v5a1 1 0 11-2 0V9zm1-4a1.5 1.5 0 100 3 1.5 1.5 0 000-3z" clip-rule="evenodd"/></svg>' },
      success: { border: 'border-emerald-200', bg: 'bg-emerald-50', text: 'text-emerald-800', icon: '<svg class="h-5 w-5 text-emerald-600" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-7.5 7.5a1 1 0 01-1.414 0l-3-3a1 1 0 111.414-1.414L8.5 12.086l6.793-6.793a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>' },
      warning: { border: 'border-amber-200',   bg: 'bg-amber-50',   text: 'text-amber-900',  icon: '<svg class="h-5 w-5 text-amber-600" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.721-1.36 3.486 0l6.518 11.6A2 2 0 0116.518 18H3.482a2 2 0 01-1.743-3.3l6.518-11.6zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-1-2a1 1 0 01-1-1V7a1 1 0 112 0v3a1 1 0 01-1 1z" clip-rule="evenodd"/></svg>' },
      error:   { border: 'border-rose-200',    bg: 'bg-rose-50',    text: 'text-rose-900',   icon: '<svg class="h-5 w-5 text-rose-600" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 10-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/></svg>' }
    }
    const m = map[this._normalizeTone(tone)] || map.info
    node.classList.add(m.border, m.bg, m.text)
    const iconEl = node.querySelector('[data-role="icon"]')
    const msgEl  = node.querySelector('[data-role="message"]')
    if (iconEl) iconEl.innerHTML = m.icon
    if (msgEl) msgEl.textContent = message

    root.appendChild(node)
  }

  _normalizeTone(t) {
    return [ 'info','success','warning','error' ].includes(t) ? t : 'info'
  }

  _createRoot() {
    const outer = document.createElement('div')
    outer.className = 'fixed inset-x-0 top-4 z-50 flex justify-center px-4 pointer-events-none'
    const inner = document.createElement('div')
    inner.id = 'flash-root'
    inner.className = 'w-full max-w-lg space-y-3 pointer-events-auto'
    outer.appendChild(inner)
    document.body.appendChild(outer)
    return inner
  }
}
